import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import "../styles/AboutUs.css";
import Banner1 from "../assets/Banner1.jpg";
import Banner2 from "../assets/Banner2.jpg";
import Banner3 from "../assets/Banner3.jpg";
import image14 from "../assets/images/image14.jpg";

const slides = [
  {
    id: 1,
    image: Banner1,
    title: "Creating Abodes of Happiness",
    subtitle: "Excellence in real estate, financial services & medicines.",
  },
  {
    id: 2,
    image: Banner2,
    title: "Innovative Real Estate Solutions",
    subtitle: "Where technology meets comfort and green living.",
  },
  {
    id: 3,
    image: Banner3,
    title: "Your Vision, Our Commitment",
    subtitle: "Delivering exceptional projects across India.",
  },
];

const variants = {
  enter: (direction) => ({ x: direction > 0 ? 300 : -300, opacity: 0 }),
  center: { x: 0, opacity: 1 },
  exit: (direction) => ({ x: direction < 0 ? 300 : -300, opacity: 0 }),
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6 },
  }),
};

const About = () => {
  const navigate = useNavigate();
  const [[page, direction], setPage] = useState([0, 0]);
  const paginate = (newDirection) =>
    setPage(([prev]) => [
      (prev + newDirection + slides.length) % slides.length,
      newDirection,
    ]);
  useEffect(() => {
    const interval = setInterval(() => paginate(1), 5000);
    return () => clearInterval(interval);
  }, [page]);
  const currentSlide = slides[page];

  const contentBlocks = [
    "Anthem Group was founded in 1995 and is an ISO 9001:2008 Certified Company with a turnover of 1,000 crore. The group stands strong on pillars of Financial Services, Medicines, and Real Estate.",
    "The Real Estate sector is booming in India, driven by innovative engineering and infrastructure growth. Anthem Group ensures every construction project follows stringent quality standards, delivering the highest customer satisfaction.",
    "Over the last 25 years, our Financial Services division has served Blue Chip MNCs and PSU clients, while our Medical sector meets global demand for medicines and surgical equipment, exporting to 34 countries.",
    "Anthem has developed several residential and commercial projects in Delhi & NCR, including over 1,000 flats in our themed 'French Apartments' project in Greater Noida (West), providing peaceful and green living environments.",
    "With a clear vision to 'Transform the way people perceive quality' in the Indian real estate industry, Anthem continues to introduce innovative projects such as 'Kingdom Mall, Homes & Apartments' in Rajnagar Extension and EWS Flats under Pradhan Mantri Awas Yojana.",
  ];

  return (
    <>
      {/* Carousel Section */}

      {/* About Section */}
      <section className="about-page">
        <motion.header
          className="about-hero"
          initial="hidden"
          animate="visible"
          variants={fadeUp}
        >
          <h1>About Anthem Group</h1>
          <p className="hero-subtitle">
            Anthem Group: Building a legacy since 1995 with excellence in Real
            Estate, Financial Services, and Medicines.
          </p>
        </motion.header>

        <div className="content-grid">
          <motion.div
            className="about-content"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            {contentBlocks.map((text, i) => (
              <motion.p
                key={i}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                {text}
              </motion.p>
            ))}

            {/* Stats */}
            <div className="stats-container">
              <motion.div className="stat-card">
                <h2>
                  <CountUp end={25} duration={2} />+
                </h2>
                <p>Years of Excellence</p>
              </motion.div>
              <motion.div className="stat-card">
                <h2>
                  <CountUp end={1000} duration={2} />+
                </h2>
                <p>Projects Delivered</p>
              </motion.div>
              <motion.div className="stat-card">
                <h2>
                  <CountUp end={34} duration={2} />+
                </h2>
                <p>Countries Exported</p>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            className="image-container"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            custom={1}
          >
            <figure>
              <img src={image14} alt="Anthem Group Building" />
              <figcaption>Anthem Group </figcaption>
            </figure>
          </motion.div>
        </div>

        {/* Capabilities */}
        <section className="about-capability">
          <div className="capability-cards">
            <h2>Our Capabilities</h2>
            <div className="capability-card">
              <h4>Real Estate</h4>
              <p>
                Delivering world-class residential & commercial projects across
                India.
              </p>
            </div>
            <div className="capability-card">
              <h4>Financial Services</h4>
              <p>
                Serving MNCs and PSU clients with tailored financial solutions.
              </p>
            </div>
            <div className="capability-card">
              <h4>Medicines</h4>
              <p>
                Exporting surgical equipment & medicines to 34 countries
                globally.
              </p>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default About;
